<template>
  <div class="map">
    <div :id="id">
      <loader-component :with_text="true" text="Sedang memuat peta" />
    </div>
  </div>
</template>

<script>
import laoder_component from "@/views/components/loader.vue";
import * as Highcharts from "highcharts/highmaps.js";
import map_id from "@/plugins/new-id-all.js";
import "highcharts/themes/grid.js";
Highcharts.maps["countries/id/id-all"] = map_id.load_data();

export default {
  name: "bubble_maps_chart",
  props: {
    dataset: Array,
    id: {
      Type: String,
      default: () => {
        return "mapcontainer";
      },
    },
    color: {
      Type: String,
      default: () => {
        return "#6f42c1";
      },
    },
    clickable: {
      Type: Boolean,
      default: () => {
        return true;
      },
    },
  },
  components: {
    "loader-component": laoder_component,
  },
  data() {
    return {
      data: this.dataset,
    };
  },
  methods: {
    HC_config: function (nv) {
      var map_config = {
        chart: {
          map: "countries/id/id-all",
          height: 35 + "%",
          backgroundColor: "transparent",
        },
        credits: {
          enabled: false,
        },
        exporting: {
          enabled: false,
        },
        title: {
          text: "",
        },
        legend: {
          enabled: false,
        },
        mapNavigation: {
          enabled: true,
          buttonOptions: {
            verticalAlign: "bottom",
          },
          enableMouseWheelZoom: false,
        },
        series: [
          {
            type: "map",
            name: "Provinsi",
            color: "#E0E0E0",
            nullColor: "#f8f9fa",
            enableMouseTracking: true,
            data: nv.data,
            dataLabels: {
              formatter: function () {
                return (
                  '<span class="point-name" data-id="' +
                  this.point.hc_key +
                  '">' +
                  this.point.name +
                  "</span>"
                );
              },
              enabled: false,
              useHTML: true,
            },
            tooltip: {
              pointFormat: "{point.name} <br/> Jumlah Mentions: {point.z} ",
            },
            cursor: "pointer",
          },
          {
            type: "mapbubble",
            name: "Jumlah Mentions",
            joinBy: "hc_key",
            color: this.color,
            data: nv.data,
            maxSize: "12%",
            marker: {
              fillOpacity: 0.6,
            },
            tooltip: {
              pointFormat: "{point.name} <br/> Jumlah Mentions: {point.z} ",
            },
            dataLabels: {
              allowOverlap: true,
              format:
                '<span class="point-name" data-code="{point.hc_key}">{point.name}</span>',
              enabled: true,
            },
            point: {
              events: {
                click: function () {
                  if (nv.clickable) {
                    nv.$parent.bubbleClicked(this);
                  }
                },
              },
            },
            cursor: "pointer",
            zIndex: 99,
          },
        ],
      };
      return map_config;
    },
  },
  mounted: function () {
    if (this.data != null) {
      new Highcharts.mapChart(this.id, this.HC_config(this));
    }
  },
};
</script>

<style scoped>
.highcharts-point {
  z-index: 999 !important;
}
.highcharts-text-outline {
  stroke-width: 0px;
  color: #f5ecec;
}
</style>